import { render } from "./QuranQari.vue?vue&type=template&id=0d544c94&scoped=true"
import script from "./QuranQari.vue?vue&type=script&lang=js"
export * from "./QuranQari.vue?vue&type=script&lang=js"

import "./QuranQari.vue?vue&type=style&index=0&id=0d544c94&scoped=true&lang=css"

import exportComponent from "/pro/vue/Attamayyuz_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d544c94"]])

export default __exports__